import type { Accessor, ContextProviderComponent } from "solid-js";
import { createContext, createSignal, untrack } from "solid-js";
import type { Editor } from "@tiptap/core";
import { initializedContext } from "../../utils/initializedUtil";

type EditorMode = "wysiwyg" | "code";
type State = {
  editor: Accessor<Editor>;
  addPlaceholder: () => void;
  mode: Accessor<EditorMode>;
  setMode: (mode: EditorMode) => void;
  codeOnly: Accessor<boolean>;
};

export const WysiwygContext = createContext<State>();
export const WysiwygProvider: ContextProviderComponent<{
  editor: Accessor<Editor>;
  addPlaceholder: () => void;
  codeOnly: Accessor<boolean>;
}> = (props) => {
  const codeOnly = untrack(() => props.value.codeOnly);
  const [mode, setMode] = createSignal<EditorMode>(untrack(codeOnly) ? "code" : "wysiwyg");

  return (
    <WysiwygContext.Provider
      value={{
        editor: untrack(() => props.value.editor),
        addPlaceholder: untrack(() => props.value.addPlaceholder),
        codeOnly,
        mode,
        setMode,
      }}
    >
      {props.children}
    </WysiwygContext.Provider>
  );
};

export const useWysiwyg = () => initializedContext(WysiwygContext, "useWysiwyg", "WysiwygProvider");
